import { createFileRoute, redirect } from "@tanstack/react-router";

import { DevicesPage } from "@/features/fleet/DevicesPage";

export const Route = createFileRoute("/_app/devices")({
  beforeLoad: ({ context }) => {
    if (context.info.edition !== "cloud" || !context.me?.permissions.includes("devices.manage")) {
      throw redirect({ to: "/worklist" });
    }
  },
  component: DevicesPage,
});
